import { render, staticRenderFns } from "./NavigationDrawerFooter.vue?vue&type=template&id=03444a20&scoped=true"
import script from "./NavigationDrawerFooter.vue?vue&type=script&lang=js"
export * from "./NavigationDrawerFooter.vue?vue&type=script&lang=js"
import style0 from "./NavigationDrawerFooter.vue?vue&type=style&index=0&id=03444a20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03444a20",
  null
  
)

export default component.exports